// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + ".app." + {"599":"bccae16","6592":"b440cd3","8500":"bccae16"}[chunkId] + ".css";
};